<template>
  <div class="pa-2" style="color: black;">
    <div class="mb-2 mr-2 ml-2" style="align-items: center; display: flex; justify-content: space-between">
      <div style="font-size: large">{{ title }}</div>
    </div>
    <div class="ma-2" style="display: flex; justify-content: space-between" >
      <div
        v-if="date !== ''"
        style="font-size: small; color: #777777">날짜: {{ date }}</div>
      <div
        v-if="author !== ''"
        style="font-size: small; color: #777777">작성자: {{ author }}</div>
    </div>
    <div v-if="this.link !== ''" class="ma-2" style="display: flex; border: 1px solid #dddddd; border-radius: 5px; align-items: center" >
      <v-icon color="#09a7b4" style="height: 30px; width: 30px">link</v-icon>
      <div style="color: #09a7b4;font-size: small; overflow-wrap: break-word; width: 85%">
        {{ link }}
      </div>
    </div>
    <div class="ma-2" style="font-size: medium; overflow-wrap: break-word; width: 90%" v-html="formattedContent"></div>
  </div>
</template>

<script>

export default {
  props: [
    'title',
    'content',
    'link',
    'date',
    'author',
    'darkMode'
  ],
  computed: {
    formattedContent () {
      return this.content.replace(/\n/g, '<br>')
    }
  }
}
</script>
